export default __webpack_public_path__ + "static/media/archive.aac32829.svg";